module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-xxl-36603e3cc3bf4f6000d800676771eb2f.svg";